import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { MenuItem, Select } from '@mui/material';
import { useEffect } from 'react';
import { AxiosInstance } from '../../api/apiInstance';
import { ICylinder } from '../../interface/IOrders_Tasks';


export interface AssemblyDialogProps {
    open: boolean;
    onClose: () => void;
    lineid: string;
    remarks: string;
    setRemarks: (value: string) => void;
    cylinder: string;
    setCylinder: (value: string) => void;
    assemblyQty: string;
    setAssemblyQty: (value: string) => void;
    _handleSaveSetAssemblyAid: (value: string) => void;


}

export default function AssemblyDialog(props: AssemblyDialogProps) {
    const { onClose, open, remarks, setRemarks, cylinder, setCylinder, _handleSaveSetAssemblyAid, lineid  ,assemblyQty , setAssemblyQty} = props;
    const [cylinderData, setCylinderData] = React.useState<ICylinder[]>([] as ICylinder[]);
    //const [remarks, setRemarks] = React.useState('');
    //const [cylinder, setCylinder] = React.useState('None');

    //   const handleClickOpen = () => {
    //     setOpen(true);
    //   };

    useEffect(() => {
        GetData();
    }, []);
    async function GetData() {
        await AxiosInstance({
            // url of the api endpoint (can be changed)
            url: "cylinder",
            method: "GET",
        }).then((res) => {
            // handle success
            const AllData = res.data as ICylinder[];
            setCylinderData(AllData);
        })
    }


    const handleSave = () => {
        _handleSaveSetAssemblyAid(lineid);

        onClose();
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <React.Fragment>

            <Dialog
                open={open}
                onClose={handleClose}
            >
                <DialogTitle>Pick Lock type</DialogTitle>


                <Select
                    sx={{ width: '90%', margin: 2 }}
                    variant='filled'
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    value={cylinder}
                    label="Cylinder"
                    onChange={e => { setCylinder(e.target.value) }}

                >
                    {cylinderData.map((c) => {
                        return (
                            <MenuItem value={c.partName}>{c.partName + ' ' + c.description}</MenuItem>
                        )
                    })}

                </Select>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="remarks"
                        name="remarks"
                        label="remarks"
                        fullWidth
                        variant="standard"
                        value={remarks}
                        onChange={(e) => { (setRemarks(e.target.value)) }}
                    />
                     <TextField
                        autoFocus
                        margin="dense"
                        id="assemblyQty"
                        name="assemblyQty"
                        label="assembly Quantity"
                        fullWidth
                        variant="standard"
                        value={assemblyQty}
                        onChange={(e) => { (setAssemblyQty(e.target.value)) }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}